/* made to store page state for #10595 */
import {
  compose,
  pathOr, path,
  lensPath, set
} from 'ramda';

// Actions
const pageActions = {
  save: 'PAGE_STATE_SAVE',
  saveCurrent: 'PAGE_STATE_SAVE_CURRENT'
};

// Action creators
export const setPage = (pagePath, state) => ({ type: pageActions.save, payload: { pagePath, state } });
export const setPageCurrent = (pagePath, state) => ({ type: pageActions.saveCurrent, payload: { pagePath, state } });

// Selectors
const getPagesRoot = pathOr({}, ['pages', 'lastFetched']);
const getPagesCurrentRoot = pathOr({}, ['pages', 'current']);

export const getPage = (pagePath) => compose(path(pagePath), getPagesRoot);
export const getPageCurrent = (pagePath) => compose(path(pagePath), getPagesCurrentRoot);

const initialState = {
  lastFetched: {},
  current: {}
};

// Reducer
export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case pageActions.save: {
      return set(
        lensPath(['lastFetched', ...payload.pagePath], state),
        payload.state,
        state
      );
    }
    case pageActions.saveCurrent: {
      return set(
        lensPath(['current', ...payload.pagePath], state),
        payload.state,
        state
      );
    }
    default:
      return state;
  }
};
